import {BillState} from "./BillState";
import {Action, handleActions} from "redux-actions";
import {BILL_FETCHED, BILL_UPDATED, BILLS_FETCHED} from "../../action/bill/actionType";
import Bill from "../../../model/bill/Bill";

const initState: BillState = {
	billsMap: {},
	billsByJobIdMap: {}
};

const reducer = handleActions({
	[BILLS_FETCHED]: (state: BillState, action: Action<any>): BillState => {
		let newBillsMap = {...state.billsMap};
		let newBillsByJobIdMap = {...state.billsByJobIdMap};
		action.payload.bills.map((bill: Bill) => {
			newBillsMap = {...newBillsMap, [bill.id]: bill};
			bill.jobId.map(jId => newBillsByJobIdMap = {...newBillsByJobIdMap, [jId]: bill})
		});
		return {...state, billsMap: newBillsMap, billsByJobIdMap: newBillsByJobIdMap};
	},
	[BILL_FETCHED]: (state: BillState, action: Action<BILL_FETCHED>): BillState => {
		const newBillsByJobIdMap = action.payload.bill.jobId.map((jId: string) => {
			return {...state.billsByJobIdMap, [jId]: action.payload.bill}
		}).getOrElse({...state.billsByJobIdMap});
		return {
			...state,
			billsMap: {...state.billsMap, [action.payload.bill.id]: action.payload.bill},
			billsByJobIdMap: newBillsByJobIdMap
		};
	},
	[BILL_UPDATED]: (state: BillState, action: Action<BILL_UPDATED>): BillState => {
		const {bill} = action.payload;
		let newBillsMap = {...state.billsMap, [bill.id]: bill};
		let newBillsByJobIdMap = state.billsByJobIdMap;
		action.payload.bill.jobId.map(jobId => {
			newBillsByJobIdMap = {...state.billsByJobIdMap, [jobId]: bill}
		})

		return {...state, billsByJobIdMap: newBillsByJobIdMap, billsMap: newBillsMap}
	}
}, initState);

export default reducer;